// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrapComponents from "./bootstrap-imports"
import "chartkick/chart.js"
import "./toast"
import "./records_chart"
import { ApiClient } from "./utils/api"
import { DomHelper } from "./utils/dom"

// window.bootstrapに必要なコンポーネントのみを設定
window.bootstrap = bootstrapComponents;
window.ApiClient = ApiClient;
window.DomHelper = DomHelper;

document.addEventListener("DOMContentLoaded", function() {
  if (typeof window.renderFlashToast === 'undefined' && typeof renderFlashToast !== 'undefined') {
    window.renderFlashToast = renderFlashToast;
  }
});
